
ADILF.define('text',{});